import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import ReCAPTCHA from 'react-google-recaptcha';
import axios from "axios";


const Appointment = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    service: "",
    date: "",
    timeslot: "",
    message: "",
    recaptchaValue: null, // Initialize the reCAPTCHA value

  });


  const [availableTimes, setAvailableTimes] = useState([]);

  const [submitDissable, setSubmitDissable] = useState(false);



  const [error, setError] = useState(null);




  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitDissable(true)
    console.log("Appointment Data:", formData);
    if (!formData.recaptchaValue) {
      setError('Please complete the reCAPTCHA verification.');
      setSubmitDissable(false)

      return;
    }
    // if (!formData.firstName || !formData.lastName || !formData.mobile || !formData.email || !formData.message || !formData.availableTimes || !formData.date) {
    //   setError('Please fill all the details');
    //   return;
    // }


    setError(null);



    // Prepare the data to be sent to the API
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      mobile: formData.phone,
      email: formData.email,
      service: formData.service,
      message: formData.message,
      appointmentDate: formData.date,
      appointmentTime: formData.timeslot
    };

    console.log("in the handel submit", payload)
    console.log("in the formData---->", formData)




    try {
      // Send data to your API endpoint using Axios
      // const response = await axios.post('http://localhost:5000/book-appointment', payload);
      const response = await axios.post('https://sbk-backend.vercel.app/book-appointment', payload);
      console.log("inside the try", payload)

      if (response.status === 201) {
        // if (false) {
        // Success: reset the form
        alert('Form submitted successfully!');
        setSubmitDissable(false)

        setFormData({
          first_name: '',
          last_name: '',
          phone: '',
          email: '',
          subject: '',
          message: '',
          recaptchaValue: null,
          date: '',
          service: '',
          setAvailableTimes: []

        });
      } else {
        setSubmitDissable(false)

        // If the server responds with a status other than 200
        setError(`Error: ${response.status} - ${response.data.message || 'Submission failed'}`);
      }
    } catch (error) {
      // Handle errors during the request
      setSubmitDissable(false)

      console.error('Error submitting form:', error);
      setError('Failed to submit the form. Please try again later.');
    }













  };



  useEffect(() => {
    const currentDate = new Date();
    const selectedDate = new Date(formData.date);

    // Function to format time slot
    const formatTime = (hour) => {
      const startHour = hour % 12 === 0 ? 12 : hour % 12;
      const endHour = (hour + 1) % 12 === 0 ? 12 : (hour + 1) % 12;
      const amPmStart = hour < 12 ? "AM" : "PM";
      const amPmEnd = (hour + 1) < 12 ? "AM" : "PM";
      return `${startHour}:00 ${amPmStart} - ${endHour}:00 ${amPmEnd}`;
    };

    // Check if selected date is today
    if (selectedDate.toDateString() === currentDate.toDateString()) {
      const currentHour = currentDate.getHours();
      const currentMinute = currentDate.getMinutes();
      const currentTime = currentHour + currentMinute / 60;

      // Generate available time slots after the current time
      const times = [];
      for (let hour = 8; hour < 20; hour++) {
        const timeSlot = formatTime(hour);
        const timeSlotStart = hour + 0; // Start time of the slot (e.g., 12:00 PM)
        const timeSlotEnd = hour + 1;   // End time of the slot (e.g., 1:00 PM)

        // If current time is greater than the start of the slot, skip it
        if (currentTime < timeSlotStart) {
          times.push(timeSlot);
        } else if (currentTime >= timeSlotEnd) {
          // Skip slots that have already passed
          continue;
        }
      }
      setAvailableTimes(times);
    } else {
      // For any other date, show times from 8 AM to 8 PM
      const times = [];
      for (let hour = 8; hour < 20; hour++) {
        times.push(formatTime(hour));
      }
      setAvailableTimes(times);
    }
  }, [formData.date]);














  const [showRecaptcha, setShowRecaptcha] = useState(false);



  const handleRecaptchaChange = (value) => {
    // Update the form state with the reCAPTCHA value
    setFormData({
      ...formData,
      recaptchaValue: value,
    });

    // Clear the error when the user completes the reCAPTCHA
    setError(null);
  };




  const handleChange = (e) => {
    // Update the form data as the user types
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    if (!showRecaptcha) {
      setShowRecaptcha(true);
    }

  };






  return (
    <>
      <div className="appointment-banner text-center py-5">
        <h3 className="fw-bold text-dark fs-2">Book An Appointment</h3>
      </div>
      <div className="container my-5">


        <div className="row shadow rounded bg-white p-2 display-flex justify-content-around">
          {/* Left Sidebar */}
          <div
            className="col-md-4 text-white appoint-img d-flex flex-column justify-content-between pt-4 px-4 "
          >

            <div className="">

              <h3 className="fw-bold ">Book Your Appointment Today</h3>
              <p>
                Our team is ready to assist with tax planning, filing, and compliance to ensure you maximize savings and avoid penalties.
              </p>
            </div>



            <div className="">

              <p>  <i className='bi bi-telephone' data-aos='fade-up'></i>  +91 92912 03306</p>
              <p>   <i className='bi bi-envelope-open'></i> contact@sbataxconsultants.com</p>
            </div>

            <img src={require('./img/call-support.png')} alt="Call support icon" className="all-sup-img" />
          </div>





          {/* Right Form Section */}


          <div className="col-md-8 py-3 ">
            <h3 className="fw-bold mt-5 mb-5 px-4 ">Share Your Information</h3>
            <form onSubmit={handleSubmit} className="px-4" >
              <div className="row">

                {/* First Name */}
                <div className="col-md-6 mb-4">
                  {/* <label className="mb-2 fw-bold">First Name <span className="text-danger">*</span></label> */}

                  <input
                    type="text"
                    className="form-control p-2"
                    placeholder="First Name"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required

                    onKeyUp={(e) => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                    }}
                  />


                </div>

                {/* Last Name */}
                <div className="col-md-6 mb-4">
                  {/* <label className="mb-2 fw-bold">Last Name <span className="text-danger">*</span></label> */}

                  <input
                    type="text"
                    className="form-control p-2"
                    placeholder="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required

                    onKeyUp={(e) => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                    }}
                  />
                </div>

                {/* Email */}
                <div className="col-md-6 mb-4">
                  {/* <label className="mb-2 fw-bold">Email address <span className="text-danger">*</span></label> */}

                  <input
                    type="email"
                    className="form-control p-2"
                    placeholder="Email Address"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    onKeyUp={(e) => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z0-9@.-]/g, ''); // Allows letters, numbers, '@', and '.'
                    }}
                  />
                </div>

                {/* Phone */}
                <div className="col-md-6 mb-4">
                  {/* <label className="mb-2 fw-bold">Phone Number <span className="text-danger">*</span></label> */}

                  <input
                    type="tel"
                    className="form-control p-2"
                    placeholder="Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    maxLength={13}
                    pattern="\d{10,13}"

                    onKeyUp={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/, ''); // Allows letters, numbers, '@', and '.'
                    }}

                  />
                </div>


                {/* DATE */}
                <div className="col-6 mb-4">
                  {/* <label className="mb-2 fw-bold">Select Date</label> */}
                  {/* <label className="mb-2 fw-bold">Prefered Date to call <span className="text-danger">*</span></label> */}

                  {/* <input
                    type="text"
                    className="form-control p-2"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    required
                    min={new Date().toISOString().split("T")[0]} // Set min date to today
                    // placeholder="Select a date"
                    onFocus={(e) => (e.target.type = "date")} // Switch to date picker on focus
                    onBlur={(e) => {
                      if (!e.target.value) e.target.type = "text"; // Revert if empty
                    }}
                    placeholder="Select a date"
                  /> */}



                  <div className="position-relative">
                    {/* Hidden Date Input */}
                    <input
                      type="date"
                      className="form-control p-2 "
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      required
                      min={new Date().toISOString().split("T")[0]}
                      ref={(input) => (window.dateInput = input)} // Store ref globally
                      style={{ opacity: 0, position: "absolute", width: "100%", height: "100%" }} // Hide actual input
                    />

                    {/* Visible Input (Fake Placeholder) */}
                    <div
                      className="form-control p-2 d-flex justify-content-between align-items-center"
                      onClick={() => window.dateInput.showPicker()} // Open date picker immediately
                      style={{ cursor: "pointer", color: formData.date ? "#000" : "#999" }}
                    >
                      {formData.date || "Select a date"}

                      {/* Calendar Icon (Right-Side Clickable) */}
                      <span role="button" className="cursor-pointer">
                        📅
                      </span>
                    </div>
                  </div>



                </div>


                {/* timeslot */}

                <div className="col-6 mb-4">
                  {/* <label className="mb-2 fw-bold">Prefered Time-slot to call <span className="text-danger">*</span></label> */}

                  {/* Dropdown */}
                  <select
                    className="form-select p-2"
                    name="timeslot"
                    value={formData.timeslot}
                    onChange={handleChange}
                    required
                  >
                    {availableTimes.map((time, index) => (
                      <option key={index} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>

                </div>







                {/* Service Dropdown */}
                <div className="col-md-12 mb-4">
                  {/* <label className="mb-2 fw-bold">Select Service <span className="text-danger">*</span></label> */}

                  <select
                    className="form-select p-2"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Service</option>
                    <option value="crporation ">Corporation Registration</option>
                    <option value="sales-tax">Sales Tax</option>
                    <option value="license">License</option>
                    <option value="bookkeeping">Bookkeeping & Business Consulting</option>
                    <option value="tax-filing">Tax Filing</option>
                    <option value="tax-consultation">Tax Consultation</option>
                    <option value="payroll">Payroll Service</option>
                    <option value="insurance">Insurance</option>
                    <option value="401k">401K Assistance</option>
                    <option value="accounting">Accounting</option>
                    <option value="itin">ITIN/IRS Related works</option>
                    <option value="nri">NRI Service</option>
                  </select>
                </div>





                <div className="col-12 mb-3">
                  <textarea
                    className="form-control"
                    placeholder="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="3"
                    required
                    maxLength={150}
                    onKeyUp={(e) => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z\s.,]/g, '');
                    }}
                  ></textarea>
                </div>


                {/* Main--  6LeeczkpAAAAAHhwk2zz9moWNOLDU_Ji61Lh1sd4   localhost--  6Lcl0ygoAAAAAHKrsouKfVZMhLnkt6qZe2ecLy9x */}

                {showRecaptcha && (
                  <>
                    <ReCAPTCHA
                      sitekey="6LeeczkpAAAAAHhwk2zz9moWNOLDU_Ji61Lh1sd4"
                      onChange={handleRecaptchaChange}
                      theme="light"
                      className="mb-4"
                    />
                    {/* Display the error message if reCAPTCHA is not completed */}
                    {/* Add your error state logic here */}
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                  </>
                )}


                {/* Submit Button */}
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn appoint-img w-100 p-3 fw-bold text-white border-0"
                    disabled={submitDissable}
                  >
                    Book Appointment
                  </button>
                </div>
              </div>
            </form>

          </div>

        </div>
















      </div>

      <section>
        <div className="container mb-5">





          {/* <div className='row align-items-center justify-content-center'>
            <div className='col-md-4 '>

              <div className=' address-contact shadow-lg rounded bg-white' style={{ padding: "35px" }}>
                <h4 className="primary-text" data-aos='fade-up'>USA Office</h4>
                <p data-aos='fade-up' className="d-flex align- gap-2">
                  <i className='bi bi-geo-alt'></i>
                  8500 N Stemmons Fwy, Dallas, Texas 75247</p>

                <p data-aos='fade-up'>
                  <a href='tel:+1 46972 25480  '>
                    <i className='bi bi-telephone-forward'></i> +1 469 722 5480
                  </a>
                </p>
                <p data-aos='fade-up'>
                  <a href='mailto:contact@sbataxconsultants.com'>
                    <i className='bi bi-envelope-open'></i> contact@sbataxconsultants.com
                  </a>
                </p>
              </div>
            </div>

            <div className='col-md-8'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='p-4 shadow-lg rounded bg-white address-contact'>
                    <h4 className="primary-text" data-aos='fade-up'>Hyderabad Office</h4>
                    <p data-aos='fade-up' className="d-flex align- gap-2">
                      <i className='bi bi-geo-alt'></i>
                      H-No:2-1-8/4/1, NR.Suite 2A, Saraswathi Colony, Uppal, Hyderabad, Telangana 500039
                    </p>

                    <p data-aos='fade-up'>
                      <a href='tel:+91 99676 23999'>
                        <i className='bi bi-telephone-forward'></i> +91 99676 23999
                      </a>
                    </p>
                    <p data-aos='fade-up'>
                      <a href='mailto:contact@sbataxconsultants.com'>
                        <i className='bi bi-envelope-open'></i> contact@sbataxconsultants.com
                      </a>
                    </p>
                  </div>
                </div>

                <div className='col-md-6'>
                  <div className='p-4 shadow-lg rounded bg-white address-contact'>
                    <h4 className="primary-text" data-aos='fade-up'>Mumbai Office</h4>
                    <p data-aos='fade-up' className="d-flex align- gap-2">
                      <i className='bi bi-geo-alt'></i> C-1011 10th Floor, Shubham Avenue, Pant Nagar Ghatkopar East, Mumbai - 400075
                    </p>
                    <p data-aos='fade-up'>
                      <a href='tel:+91 99676 23999'>
                        <i className='bi bi-telephone-forward'></i> +91 99676 23999
                      </a>
                    </p>
                    <p data-aos='fade-up'>
                      <a href='mailto:contact@sbataxconsultants.com'>
                        <i className='bi bi-envelope-open'></i> contact@sbataxconsultants.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}



           <div className="col-md-12  py-3 px-5">




              <div className='row justify-content-center p-4 '>
                <div className='col-md-4'>

                  <div className=' address-contact shadow-lg rounded bg-white' style={{ padding: "35px" }}>
                    <h4 data-aos='fade-up'>USA Office</h4>
                    <p data-aos='fade-up' className="d-flex align- gap-2 mt-5">
                      <i className='bi bi-geo-alt'></i>
                      8500 N Stemmons Fwy, Dallas, Texas 75247</p>

                    {/* <p data-aos='fade-up'>
                      <a href='tel:+1 469 722 5480' className='email-link '>
                        <i className='bi bi-telephone-forward'></i> +1 469 722 5480
                      </a>
                    </p> */}
                      {/* <a href='mailto:contact@sbataxconsultants.com'>
                        <i className='bi bi-envelope-open'></i> contact@sbataxconsultants.com
                      </a> */}
                    {/* <p data-aos='fade-up'>


                      <a href="mailto:contact@sbataxconsultants.com"
                        className="text-decoration-none email-link">
                        <i className="bi bi-envelope-open"></i> contact@sbataxconsultants.com
                      </a>

                    </p> */}
                  </div>
                </div>








              
                    <div className='col-md-4'>
                      <div className='p-4 shadow-lg rounded bg-white address-contact'>
                        <h4 data-aos='fade-up'>Hyderabad Office</h4>
                        <p data-aos='fade-up' className="d-flex align- gap-2 mt-5">
                          <i className='bi bi-geo-alt'></i>
                          H-No:2-1-8/4/1, NR.Suite 2A, Saraswathi Colony, Uppal, Hyderabad, Telangana 500039
                        </p>

                        {/* <p data-aos='fade-up'>
                          <a href='tel:+91 99676 23999 ' className='email-link '>
                            <i className='bi bi-telephone-forward'></i> +91 99676 23999
                          </a>
                        </p>
                        <p data-aos='fade-up'>
                          <a href='mailto:contact@sbataxconsultants.com' className='email-link '>

                            <i className='bi bi-envelope-open fs-7'></i> contact@sbataxconsultants.com
                          </a>
                        </p> */}
                      </div>
                    </div>

                    {/* <div className='col-md-6 mt-3'>
                      <div className='p-4 shadow-lg rounded bg-white address-contact'>
                        <h4 data-aos='fade-up'>Mumbai Office</h4>
                        <p data-aos='fade-up' className="d-flex align- gap-2">
                          <i className='bi bi-geo-alt'></i> C-1011 10th Floor, Shubham Avenue, Pant Nagar Ghatkopar East, Mumbai - 400075
                        </p>
                        <p data-aos='fade-up'>
                          <a href='tel:+91 99676 23999' className='email-link '>
                            <i className='bi bi-telephone-forward'></i> +91 99676 23999
                          </a>
                        </p>
                        <p data-aos='fade-up'>
                          <a href='mailto:contact@sbataxconsultants.com' className='email-link '>
                            <i className='bi bi-envelope-open'></i> contact@sbataxconsultants.com
                          </a>
                        </p>
                      </div>
                    </div> */}


                    <div className='col-md-4'>
                      <div className='p-4 shadow-lg rounded bg-white address-contact'>
                        {/* <h4 data-aos='fade-up'>Contact</h4> */}
                        
                        <p data-aos='fade-up'>
                        <h6>India</h6>
                          <a href='tel:+91 92912 03306' className='email-link '>
                            <i className='bi bi-telephone-forward'></i>  +91 92912 03306
                          </a>
                        </p>
                        <p data-aos='fade-up'>
                        <h6>USA</h6>
                          <a href='tel:+1 469 722 5480' className='email-link '>
                            <i className='bi bi-telephone-forward'></i> +1 469 722 5480
                          </a>
                        </p>
                        <p className='mb-1 pb-0' data-aos='fade-up'>
                          <a href='mailto:contact@sbataxconsultants.com' className='email-link '>
                            <i className='bi bi-envelope-open'></i> contact@sbataxconsultants.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
               




            </div>





        </div>
      </section>
    </>
  );
};

export default Appointment;
